import React, { useState } from "react";
import "./Add_Bank_Account.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { Form, Button } from "react-bootstrap";
import Select from "react-select";
import { FaUser, FaCreditCard, FaPhone, FaKey, FaInfoCircle, FaIdCard } from "react-icons/fa";
import { faBuildingColumns } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AddBankAccount } from "../../features/wallet/slice"; // adjust path as needed
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";

const bankOptions = [
  { value: "State Bank Of India", label: "State Bank Of India" },
  { value: "HDFC Bank", label: "HDFC Bank" },
  { value: "ICICI Bank", label: "ICICI Bank" },
  { value: "Axis Bank", label: "Axis Bank" },
  { value: "Punjab National Bank", label: "Punjab National Bank" },
];

function Add_Bank_Account() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("Suceesfull");
  const {
    control,
    register,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      bank_name: null,
      account_holder_name: "",
      account_number: "",
      confirm_account_number: "",
      contact_no: "",
      ifsc_code: "",
    },
  });

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("bank_name", data?.bank_name);
      formData.append("account_holder_name", data?.account_holder_name);
      formData.append("account_number", data?.account_number);
      formData.append("contact_no", data?.contact_no);
      formData.append("ifsc_code", data?.ifsc_code);
      formData.append("upi_id", data?.upi_id);

      const res = await dispatch(AddBankAccount(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setModalShow(true);
        setModalMessage(res?.payload?.data);
        setTimeout(() => {
          setModalShow(false);
          navigate("/bank-account");
        }, 3000);

      } else {
        setModalShow(true);
        setModalMessage(res?.payload?.errors || "Deposit failed.");
        setTimeout(() => {
          setModalShow(false);
        }, 3000);
        console.error("Add bank failed:", res?.payload?.errors);
      }
    } catch (error) {
      console.error("Add bank error:", error);
    }
  };

  return (
    <section className="Add_Bank_Account">
      <Common_white_header headingText={"Add a Bank Account"} />

      <div className="container">
        <div className="Add_Bank_Account_holder">

          {/* Info Message */}
          <div className="info-box">
            <FaInfoCircle className="info-icon" />
            <span>
              To ensure the safety of your funds, please bind your bank account
            </span>
          </div>

          <Form className="bank-form field_holder" onSubmit={handleSubmit(onSubmit)} noValidate>

            {/* Choose Bank */}
            <Form.Group className="form-group">
              <Form.Label>
                <FontAwesomeIcon icon={faBuildingColumns} className="input-icon" />{" "}
                Enter a bank
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Bank name"
                {...register("bank_name", {
                  required: "Bank  name is required",
                })}
              />
              {errors.bank_name && (
                <small className="text-danger">{errors.bank_name.message}</small>
              )}
            </Form.Group>

            {/* Full Name */}
            <Form.Group className="form-group">
              <Form.Label>
                <FaUser className="input-icon" /> Full recipient's name
              </Form.Label>
              <div className="input-with-icon">
                <Form.Control
                  type="text"
                  placeholder="Enter name"
                  {...register("account_holder_name", {
                    required: "Full name is required",
                  })}
                />
              </div>
              {errors.account_holder_name && (
                <small className="text-danger">{errors.account_holder_name.message}</small>
              )}
            </Form.Group>

            {/* Account Number */}
            <Form.Group className="form-group">
              <Form.Label>
                <FaCreditCard className="input-icon" /> Bank account number
              </Form.Label>
              <div className="input-with-icon">
                <Form.Control
                  type="text"
                  placeholder="Enter 9–18 digit account number"
                  maxLength={18}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) e.preventDefault();
                  }}
                  onPaste={(e) => {
                    const pasted = e.clipboardData.getData("text");
                    if (!/^[0-9]+$/.test(pasted)) e.preventDefault();
                  }}
                  {...register("account_number", {
                    required: "Account number is required",
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Only digits are allowed",
                    },
                    minLength: {
                      value: 9,
                      message: "Account number must be at least 9 digits",
                    },
                    maxLength: {
                      value: 18,
                      message: "Account number cannot exceed 18 digits",
                    },
                    validate: {
                      noAllSame: (value) =>
                        !/^(.)+$/.test(value) ||
                        "Account number cannot be all same digits",
                      noLeadingZero: (value) =>
                        value[0] !== "0" ||
                        "Account number cannot start with 0",
                    },
                  })}
                />
              </div>
              {errors.account_number && (
                <small className="text-danger">{errors.account_number.message}</small>
              )}
            </Form.Group>

            {/* Confirm Account Number */}
            <Form.Group className="form-group">
              <Form.Label>
                <FaCreditCard className="input-icon" /> Confirm Bank account number
              </Form.Label>
              <div className="input-with-icon">
                <Form.Control
                  type="text"
                  placeholder="Confirm Bank account number"
                  {...register("confirm_account_number", {
                    required: "Please confirm your account number",
                    validate: (value) =>
                      value === watch("account_number") || "Account numbers do not match",
                  })}
                />
              </div>
              {errors.confirm_account_number && (
                <small className="text-danger">{errors.confirm_account_number.message}</small>
              )}
            </Form.Group>

            {/* Phone */}
            <Form.Group className="form-group">
              <Form.Label>
                <FaPhone className="input-icon" /> Phone number
              </Form.Label>
              <div className="input-with-icon">
                <Form.Control
                  type="text"
                  placeholder="Enter Phone number"
                  maxLength={10}
                  {...register("contact_no", {
                    required: "Phone number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Enter a valid 10-digit phone number",
                    },
                  })}
                />
              </div>
              {errors.contact_no && (
                <small className="text-danger">{errors.contact_no.message}</small>
              )}
            </Form.Group>

            {/* IFSC */}
            <Form.Group className="form-group">
              <Form.Label>
                <FaKey className="input-icon" /> IFSC Code
              </Form.Label>
              <div className="input-with-icon">
                <Form.Control
                  type="text"
                  placeholder="Please enter IFSC code"
                  {...register("ifsc_code", {
                    required: "IFSC code is required",
                    pattern: {
                      value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                      message: "Enter a valid IFSC code (e.g. SBIN0001234)",
                    },
                  })}
                />
              </div>
              {errors.ifsc_code && (
                <small className="text-danger">{errors.ifsc_code.message}</small>
              )}
            </Form.Group>
            <Form.Group className="form-group">
              <Form.Label>
                <FaIdCard className="input-icon" /> UPI ID
              </Form.Label>
              <div className="input-with-icon">
                <Form.Control
                  type="text"
                  placeholder="Please enter UPI ID"
                  {...register("upi_id", {
                    required: "UPI ID is required",
                    pattern: {
                      value: /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/,
                      message: "Enter a valid UPI ID",
                    },
                  })}
                />
              </div>
              {errors.upi_id && (
                <small className="text-danger">{errors.upi_id.message}</small>
              )}
            </Form.Group>

            {/* Save Button */}
            <Button
              type="submit"
              className="btn_register_bg"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Saving..." : "Save"}
            </Button>
          </Form>
        </div>
      </div>
      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </section>
  );
}

export default Add_Bank_Account;